var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// @todo [ui-kit]: useNativeSelectOnMobile
import React, { useCallback, useMemo, useState } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function (theme) { return ({
    container: {
        color: theme.palette.grey[900],
        height: '48px',
    },
    paperContainer: {
        maxHeight: '290px',
    },
    placeholderStyle: {
        color: theme.palette.grey[500],
    },
}); };
var SelectField = function (props) {
    var name = props.name, options = props.options, placeholder = props.placeholder, propsToPass = __rest(props, ["name", "options", "placeholder"]);
    var _a = useEmotionStyles(styles), container = _a.container, paperContainer = _a.paperContainer, placeholderStyle = _a.placeholderStyle;
    var _b = useState(false), autoFocus = _b[0], setAutoFocus = _b[1];
    var optionKeydownHandler = useCallback(function (keyboardEvent) {
        return setAutoFocus(keyboardEvent.key === 'ArrowUp' || keyboardEvent.key === 'ArrowDown');
    }, []);
    var menuProps = useMemo(function () {
        return {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            getContentAnchorEl: null,
            autoFocus: autoFocus,
            classes: { paper: paperContainer },
            onKeyDown: optionKeydownHandler,
        };
    }, [autoFocus, optionKeydownHandler]);
    var shouldDisplayPlaceholder = !!(!props.value && placeholder);
    return (React.createElement(Select, __assign({}, propsToPass, { displayEmpty: shouldDisplayPlaceholder }, (shouldDisplayPlaceholder && {
        renderValue: function () { return (React.createElement("span", { className: placeholderStyle }, placeholder)); },
    }), { "data-testid": "simple-select", name: name, id: props.id || name, className: "".concat(container, " ").concat(props.className), fullWidth: true, variant: "outlined", color: "primary", defaultValue: "", MenuProps: menuProps }), options === null || options === void 0 ? void 0 : options.map(function (option) {
        var currentOptionLabel = option.label;
        if (currentOptionLabel === '') {
            return null;
        }
        return (React.createElement(MenuItem, { key: String(option.value), value: option.value, disabled: !!option.disabled }, option.label));
    })));
};
export default SelectField;
